import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import clsx from 'clsx';
import { Link } from 'gatsby';
import { slugify } from '../../lib/utils';

export default function BlogPostTableOfContents(blok) {
  const { headings, location } = blok;

  if ((!headings || Array.isArray(headings)) && headings.length === 0) {
    return null;
  }

  const styles = clsx(
    'blok-blogpost-table-of-contents my-5 font-bold',
  );

  const handleClick = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <p className="font-bold">{location.pathname.includes('/en/') ? 'Table of contents' : 'Inhaltsverzeichnis'}</p>
      <ol className="list-decimal ml-4">
        {headings.map((heading) => {
          if (!heading || !heading.text) return null;
          const id = slugify(heading.text);
          return (
            <li key={id}>
              <Link to={`${location.pathname}#${id}`} onClick={(e) => handleClick(e, id)}>{heading.text}</Link>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
